(() => {
  const STYLE_ID = 'intention-gateway-stage-styles';
  const PAGE_PROMO_STYLE_ID = 'intention-page-promo-styles';
  const PAGE_PROMO_ID = 'intention-free-shipping-banner';
  const ENHANCED_ATTR = 'data-intention-gateway-enhanced';
  const EMAIL_ENHANCED_ATTR = 'data-intention-email-enhanced';
  const COVER_PROGRESS_CLASS = 'cover-progress-panel';
  const ENTRY_PATH_ATTR = 'data-intention-entry-path';
  const ENTRY_PATH_STORAGE_KEY = 'intention-squared-entry-path';
  const JOURNAL_DRAFT_KEY = 'intention-squared-celestial-draft-v1';
  const HERO_IMAGE = 'https://cdn.shopify.com/s/files/1/0783/3924/4187/files/intention-squared-celestial-journal-builder.png?v=1790381053&width=1600';
  let pendingMarketingOptIn = null;
  let coverProgressTimer = null;
  let activeCoverProgressPanel = null;

  const styles = `
    :host {
      scroll-margin-top: 92px;
    }

    .marketplace-product.gateway-stage-shell {
      width: min(1440px, calc(100vw - 24px)) !important;
      max-width: none !important;
      margin-inline: auto !important;
    }

    .marketplace-product.gateway-stage-shell > .product-details-column {
      width: 100% !important;
      max-width: none !important;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] {
      display: grid !important;
      grid-template-columns: minmax(330px, .88fr) minmax(0, 1.12fr) !important;
      grid-template-areas:
        "visual kicker"
        "visual title"
        "visual intro"
        "visual progress"
        "visual choice"
        "visual options"
        "reassurance reassurance" !important;
      column-gap: clamp(36px, 5vw, 78px) !important;
      row-gap: 0 !important;
      width: min(1380px, calc(100% - 40px)) !important;
      max-width: none !important;
      margin: 28px auto 54px !important;
      padding: clamp(28px, 4vw, 56px) !important;
      border: 1px solid #dfd1c4 !important;
      border-radius: 28px !important;
      background:
        radial-gradient(circle at 6% 7%, rgba(193, 91, 54, .11), transparent 31%),
        linear-gradient(145deg, #fffdf9 0%, #fff9f1 56%, #f8eee4 100%) !important;
      box-shadow: 0 28px 70px rgba(62, 38, 24, .12) !important;
      overflow: hidden !important;
      position: relative !important;
      isolation: isolate;
    }

    .quiz-start[${ENHANCED_ATTR}="true"]::before {
      content: "" !important;
      display: block !important;
      position: absolute !important;
      width: 290px !important;
      height: 290px !important;
      right: -125px !important;
      top: -125px !important;
      border: 1px solid rgba(160, 73, 42, .14) !important;
      border-radius: 50% !important;
      box-shadow: 0 0 0 34px rgba(160, 73, 42, .035), 0 0 0 72px rgba(160, 73, 42, .025) !important;
      pointer-events: none !important;
      z-index: -1 !important;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-visual {
      grid-area: visual;
      min-height: 560px;
      border-radius: 22px;
      background: #fff;
      box-shadow: 0 22px 50px rgba(41, 26, 18, .2);
      overflow: hidden;
      position: relative;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-visual img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      display: block;
      transform: scale(1.04);
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-visual::after {
      content: "";
      position: absolute;
      inset: 0;
      background: linear-gradient(180deg, transparent 52%, rgba(20, 16, 13, .68) 100%);
      pointer-events: none;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-visual-badge {
      position: absolute;
      left: 22px;
      right: 22px;
      bottom: 20px;
      z-index: 2;
      color: #fffaf4;
      display: flex;
      align-items: end;
      justify-content: space-between;
      gap: 18px;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-visual-badge strong,
    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-visual-badge span {
      display: block;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-visual-badge strong {
      font-family: Georgia, "Times New Roman", serif;
      font-size: 21px;
      line-height: 1.1;
      font-weight: 500;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-visual-badge span {
      margin-top: 5px;
      color: rgba(255, 250, 244, .82);
      font-size: 12px;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-price-pill {
      flex: none;
      margin: 0 !important;
      padding: 8px 11px;
      border: 1px solid rgba(255,255,255,.28);
      border-radius: 999px;
      background: rgba(24, 20, 17, .56);
      backdrop-filter: blur(8px);
      color: #fffaf4 !important;
      font-size: 13px !important;
      font-weight: 700;
      white-space: nowrap;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-kicker {
      grid-area: kicker;
      margin: 4px 0 14px !important;
      color: #a4492d !important;
      font-size: 12px !important;
      font-weight: 800 !important;
      line-height: 1.2 !important;
      letter-spacing: .17em !important;
      text-transform: uppercase;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] > h2 {
      grid-area: title;
      max-width: 690px !important;
      margin: 0 !important;
      font-family: Georgia, "Times New Roman", serif !important;
      font-size: clamp(38px, 4.7vw, 62px) !important;
      font-weight: 400 !important;
      line-height: 1.02 !important;
      letter-spacing: -.038em !important;
      color: #2f251f !important;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] > p:not(.quiz-product-context):not(.gateway-kicker):not(.gateway-reassurance):not(.gateway-choice-prompt) {
      grid-area: intro;
      max-width: 680px !important;
      margin: 20px 0 0 !important;
      color: #6d6056 !important;
      font-size: 16px !important;
      line-height: 1.65 !important;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-progress {
      grid-area: progress;
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 10px;
      margin: 26px 0 0;
      padding: 0;
      list-style: none;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-progress li {
      display: grid;
      grid-template-columns: 27px minmax(0, 1fr);
      align-items: center;
      gap: 8px;
      min-width: 0;
      color: #7a6a5d;
      font-size: 11px;
      font-weight: 700;
      line-height: 1.25;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-progress b {
      width: 27px;
      height: 27px;
      border: 1px solid #c88a70;
      border-radius: 50%;
      display: grid;
      place-items: center;
      color: #9d452b;
      background: #fffaf5;
      font-size: 11px;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .quiz-start-options {
      grid-area: options;
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 15px !important;
      margin-top: 12px !important;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-choice-prompt {
      grid-area: choice;
      margin: 23px 0 0 !important;
      color: #4d4037 !important;
      font-size: 12px !important;
      font-weight: 800 !important;
      letter-spacing: .11em !important;
      text-transform: uppercase;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .quiz-start-option {
      display: flex !important;
      flex-direction: column;
      align-items: flex-start;
      min-height: 260px !important;
      margin: 0 !important;
      padding: 24px 22px 22px !important;
      border: 1px solid #ddcdbf !important;
      border-radius: 20px !important;
      background: rgba(255, 253, 249, .94) !important;
      box-shadow: 0 12px 28px rgba(72, 46, 30, .075) !important;
      transform: translateY(0);
      transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease !important;
      overflow: hidden;
      cursor: pointer !important;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .quiz-start-option.quiz-start-guided {
      background: linear-gradient(155deg, #f3f6f8 0%, #E3E8ED 100%) !important;
      border-color: #b5c3ce !important;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .quiz-start-option::before,
    .quiz-start[${ENHANCED_ATTR}="true"] .quiz-start-option::after {
      display: none !important;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .quiz-start-option:hover {
      transform: translateY(-5px) !important;
      border-color: #a64f31 !important;
      box-shadow: 0 20px 38px rgba(72, 46, 30, .14) !important;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .quiz-start-option:focus-visible {
      outline: 3px solid #a64f31 !important;
      outline-offset: 4px !important;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-option-icon {
      width: 48px;
      height: 48px;
      margin-bottom: 25px;
      border-radius: 14px;
      display: grid;
      place-items: center;
      color: #a64f31;
      background: #f7e8dd;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .quiz-start-guided .gateway-option-icon {
      color: #526B80;
      background: #d9e2e9;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-option-icon svg {
      width: 26px;
      height: 26px;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .quiz-start-option strong {
      margin: 0 0 9px !important;
      font-family: Georgia, "Times New Roman", serif !important;
      font-size: 23px !important;
      font-weight: 500 !important;
      line-height: 1.14 !important;
      color: #312720 !important;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .quiz-start-option > span:not(.gateway-option-icon):not(.gateway-option-cta) {
      margin-bottom: 20px !important;
      color: #706259 !important;
      font-size: 13px !important;
      line-height: 1.55 !important;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-option-cta {
      width: 100%;
      margin-top: auto;
      padding: 13px 16px;
      box-sizing: border-box;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #a64f31;
      color: #fffaf4 !important;
      font-size: 13px !important;
      font-weight: 800 !important;
      letter-spacing: .02em;
      box-shadow: 0 8px 16px rgba(143, 63, 39, .16);
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .quiz-start-guided .gateway-option-cta {
      background: #526B80;
      color: #fffef8 !important;
      box-shadow: 0 8px 16px rgba(82, 107, 128, .16);
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-option-cta i {
      font-size: 20px;
      font-style: normal;
      transition: transform .18s ease;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .quiz-start-option:hover .gateway-option-cta i {
      transform: translateX(4px);
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .quiz-product-context {
      grid-area: context;
      width: fit-content !important;
      margin: 18px 0 0 !important;
      padding: 8px 12px !important;
      border: 1px solid #dfcbbb !important;
      border-radius: 999px !important;
      background: rgba(255,255,255,.62) !important;
      color: #65564b !important;
      font-size: 12px !important;
      font-weight: 650 !important;
      letter-spacing: 0 !important;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-reassurance {
      grid-area: reassurance;
      grid-column: 1 / -1 !important;
      width: 100% !important;
      max-width: none !important;
      box-sizing: border-box;
      margin: 36px 0 0 !important;
      padding: 18px 22px;
      border: 1px solid #e5d7ca;
      border-radius: 15px;
      background: rgba(255,255,255,.56);
      color: #5f5147 !important;
      font-size: 14px !important;
      line-height: 1.5 !important;
      text-align: center;
    }

    .quiz-start[${ENHANCED_ATTR}="true"] .gateway-reassurance strong {
      color: #9d452b;
    }

    .gateway-return-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 18px;
      margin: 0 0 22px;
      padding: 13px 16px;
      border: 1px solid #e3d5c9;
      border-radius: 14px;
      background: #fffaf5;
    }

    .gateway-return-button {
      appearance: none;
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 0;
      border: 0;
      background: transparent;
      color: #9d452b;
      font: inherit;
      font-size: 14px;
      font-weight: 800;
      cursor: pointer;
    }

    .gateway-return-button:hover {
      color: #71301f;
      text-decoration: underline;
      text-underline-offset: 3px;
    }

    .gateway-return-button:focus-visible {
      outline: 3px solid #a64f31;
      outline-offset: 4px;
      border-radius: 3px;
    }

    .gateway-return-note {
      margin: 0 !important;
      color: #74675d !important;
      font-size: 12px !important;
      line-height: 1.4 !important;
      text-align: right;
    }

    :host([${ENTRY_PATH_ATTR}="manual"]) .goal-start-options,
    :host([${ENTRY_PATH_ATTR}="manual"]) #goal-helper-prefilled,
    :host([${ENTRY_PATH_ATTR}="manual"]) #goal-helper-assisted {
      display: none !important;
    }

    :host([${ENTRY_PATH_ATTR}="manual"]) #goal-helper-manual {
      margin-top: 18px !important;
    }

    .quiz-email-gate[${EMAIL_ENHANCED_ATTR}="true"] {
      display: grid;
      gap: 18px;
    }

    .quiz-email-gate[${EMAIL_ENHANCED_ATTR}="true"] .quiz-email-intro {
      margin: 0 !important;
      color: #54483f !important;
      font-size: 16px !important;
      line-height: 1.55 !important;
    }

    .quiz-email-gate[${EMAIL_ENHANCED_ATTR}="true"] .quiz-text-field {
      margin: 0 !important;
    }

    .quiz-email-gate[${EMAIL_ENHANCED_ATTR}="true"] .quiz-marketing-optin {
      display: grid;
      grid-template-columns: 20px minmax(0, 1fr);
      align-items: start;
      gap: 11px;
      margin: 0;
      padding: 15px 16px;
      border: 1px solid #e2d3c6;
      border-radius: 12px;
      background: #fffaf5;
      color: #554940;
      font-size: 14px;
      line-height: 1.5;
      cursor: pointer;
    }

    .quiz-email-gate[${EMAIL_ENHANCED_ATTR}="true"] .quiz-marketing-optin input {
      width: 18px;
      height: 18px;
      margin: 2px 0 0;
      accent-color: #a64f31;
    }

    .quiz-email-gate[${EMAIL_ENHANCED_ATTR}="true"] .quiz-marketing-optin:focus-within {
      outline: 3px solid rgba(166, 79, 49, .28);
      outline-offset: 2px;
    }

    .quiz-email-gate[${EMAIL_ENHANCED_ATTR}="true"] .quiz-submit {
      margin: 0 !important;
    }

    .quiz-email-gate[${EMAIL_ENHANCED_ATTR}="true"] .quiz-privacy-notice {
      margin: -4px 0 0 !important;
      color: #74675d !important;
      font-size: 12px !important;
      line-height: 1.55 !important;
    }

    .quiz-email-gate[${EMAIL_ENHANCED_ATTR}="true"] .quiz-privacy-notice a {
      color: #8f3f27;
      font-weight: 700;
      text-underline-offset: 3px;
    }

    .${COVER_PROGRESS_CLASS} {
      margin: 18px 0 0;
      padding: 18px 19px 17px;
      border: 1px solid #dfcabb;
      border-radius: 15px;
      background:
        radial-gradient(circle at 100% 0%, rgba(166, 79, 49, .10), transparent 42%),
        #fffaf5;
      box-shadow: 0 10px 25px rgba(80, 48, 31, .08);
    }

    .${COVER_PROGRESS_CLASS} + p {
      display: none !important;
    }

    .cover-progress-copy {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      gap: 16px;
      margin-bottom: 11px;
    }

    .cover-progress-message {
      color: #46382f;
      font-size: 15px;
      font-weight: 800;
      line-height: 1.4;
    }

    .cover-progress-percent {
      flex: none;
      color: #9d452b;
      font-size: 13px;
      font-weight: 800;
      font-variant-numeric: tabular-nums;
    }

    .cover-progress-track {
      width: 100%;
      height: 12px;
      overflow: hidden;
      border-radius: 999px;
      background: #eadfd5;
      box-shadow: inset 0 1px 2px rgba(55, 35, 24, .10);
    }

    .cover-progress-fill {
      display: block;
      width: 8%;
      height: 100%;
      border-radius: inherit;
      background: linear-gradient(90deg, #a64f31 0%, #c87550 72%, #dda17f 100%);
      box-shadow: 0 2px 8px rgba(166, 79, 49, .28);
      position: relative;
      transition: width .48s ease;
    }

    .cover-progress-fill::after {
      content: "";
      position: absolute;
      inset: 0;
      background: linear-gradient(105deg, transparent 25%, rgba(255,255,255,.42) 50%, transparent 75%);
      transform: translateX(-100%);
      animation: cover-progress-shimmer 1.7s ease-in-out infinite;
    }

    .cover-progress-note {
      margin: 10px 0 0 !important;
      color: #74675d !important;
      font-size: 13px !important;
      line-height: 1.45 !important;
    }

    @keyframes cover-progress-shimmer {
      to { transform: translateX(100%); }
    }

    @media (prefers-reduced-motion: reduce) {
      .cover-progress-fill {
        transition: none;
      }

      .cover-progress-fill::after {
        animation: none;
      }
    }

    @media (max-width: 980px) {
      .quiz-start[${ENHANCED_ATTR}="true"] {
        grid-template-columns: minmax(270px, .78fr) minmax(0, 1.22fr) !important;
        column-gap: 28px !important;
        padding: 30px !important;
      }

      .quiz-start[${ENHANCED_ATTR}="true"] .gateway-visual {
        min-height: 500px;
      }

      .quiz-start[${ENHANCED_ATTR}="true"] .quiz-start-options {
        grid-template-columns: 1fr !important;
      }

      .quiz-start[${ENHANCED_ATTR}="true"] .quiz-start-option {
        min-height: 210px !important;
      }
    }

    @media (max-width: 720px) {
      .quiz-start[${ENHANCED_ATTR}="true"] {
        grid-template-columns: minmax(0, 1fr) !important;
        grid-template-areas:
          "kicker"
          "title"
          "intro"
          "visual"
          "progress"
          "choice"
          "options"
          "reassurance" !important;
        width: min(100% - 24px, 620px) !important;
        margin: 16px auto 38px !important;
        padding: 25px 20px 28px !important;
        border-radius: 22px !important;
      }

      .quiz-start[${ENHANCED_ATTR}="true"] > h2 {
        font-size: clamp(35px, 11vw, 50px) !important;
      }

      .quiz-start[${ENHANCED_ATTR}="true"] .gateway-visual {
        min-height: 360px;
        margin-top: 26px;
      }

      .quiz-start[${ENHANCED_ATTR}="true"] .gateway-progress {
        margin-top: 24px;
        gap: 16px;
      }

      .quiz-start[${ENHANCED_ATTR}="true"] .gateway-progress li {
        grid-template-columns: minmax(0, 1fr);
        align-content: start;
        justify-items: center;
        gap: 9px;
        text-align: center;
        overflow-wrap: anywhere;
      }

      .quiz-start[${ENHANCED_ATTR}="true"] .gateway-progress li span {
        min-width: 0;
        max-width: 100%;
      }

      .quiz-start[${ENHANCED_ATTR}="true"] .gateway-choice-prompt {
        margin-top: 22px !important;
        text-align: left;
      }

      .quiz-start[${ENHANCED_ATTR}="true"] .quiz-start-options {
        grid-template-columns: 1fr !important;
      }

      .quiz-start[${ENHANCED_ATTR}="true"] .quiz-start-option {
        min-height: 220px !important;
      }

      .gateway-return-row {
        align-items: flex-start;
        flex-direction: column;
        gap: 6px;
      }

      .gateway-return-note {
        text-align: left;
      }

    }

    @media (prefers-reduced-motion: reduce) {
      .quiz-start[${ENHANCED_ATTR}="true"] .quiz-start-option,
      .quiz-start[${ENHANCED_ATTR}="true"] .gateway-option-cta i {
        transition: none !important;
      }
    }
  `;

  const manualIcon = `
    <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true">
      <rect x="5" y="5" width="22" height="22" rx="3"></rect>
      <path d="M12.3 5v22M19.7 5v22M5 12.3h22M5 19.7h22"></path>
      <path d="m18.6 21.4 6.7-6.7 2 2-6.7 6.7-3.1 1.1 1.1-3.1Z" fill="#fffaf5"></path>
    </svg>`;

  const guidedIcon = `
    <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true">
      <path d="M16 4.5a8 8 0 0 0-5.2 14.1c1.2 1 2 2.1 2.2 3.4h6c.2-1.3 1-2.4 2.2-3.4A8 8 0 0 0 16 4.5Z"></path>
      <path d="M11.5 22h9M12.5 25h7M14 28h4"></path>
      <path d="M16 1v2M5.8 5.8l1.4 1.4M26.2 5.8l-1.4 1.4M2 15h2M28 15h2"></path>
    </svg>`;

  function ensureStyles(root) {
    if (root.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = styles;
    root.prepend(style);
  }

  function setEntryPath(root, path) {
    root.host?.setAttribute(ENTRY_PATH_ATTR, path);
    try {
      window.sessionStorage.setItem(ENTRY_PATH_STORAGE_KEY, path);
    } catch {}
  }

  function clearEntryPath(root) {
    root.host?.removeAttribute(ENTRY_PATH_ATTR);
    try {
      window.sessionStorage.removeItem(ENTRY_PATH_STORAGE_KEY);
    } catch {}
  }

  function restoreEntryPath(root) {
    try {
      const path = window.sessionStorage.getItem(ENTRY_PATH_STORAGE_KEY);
      if (path === 'manual' || path === 'guided') {
        root.host?.setAttribute(ENTRY_PATH_ATTR, path);
      }
    } catch {}
  }

  function hasSavedProject(root) {
    const liveInputs = Array.from(root.querySelectorAll('.goals-grid input, input[aria-label^="Goal "]'));
    if (liveInputs.some((input) => input instanceof HTMLInputElement && input.value.trim())) return true;

    try {
      const raw = window.localStorage.getItem(JOURNAL_DRAFT_KEY);
      if (!raw) return false;
      const stored = JSON.parse(raw);
      const journal = stored?.journal;
      if (!journal || typeof journal !== 'object') return false;
      if (typeof journal.titleLine1 === 'string' && journal.titleLine1.trim()) return true;
      if (typeof journal.titleLine2 === 'string' && journal.titleLine2.trim()) return true;
      return Array.isArray(journal.goals)
        && journal.goals.some((goal) => typeof goal === 'string' && goal.trim());
    } catch {
      return false;
    }
  }

  function storefrontPriceText(root) {
    // Reuse the exact Liquid-formatted presentment price consumed by the editor.
    // Never reinterpret a currency symbol, calculate an exchange rate, or fall back to USD.
    try {
      const data = root.host?.querySelector('script[type="application/json"]');
      const runtime = JSON.parse(data?.textContent || '{}');
      const text = runtime.variants?.celestial?.priceText;
      return typeof text === 'string' && text.trim() ? text.trim() : null;
    } catch {
      return null;
    }
  }

  // A recommendation for this season, not a supplier-backed delivery guarantee.
  const CHRISTMAS_CUTOFF = Date.parse('2026-12-09T00:00:00-07:00');
  const CHRISTMAS_END = Date.parse('2026-12-26T00:00:00-07:00');
  function christmasRemaining(now) {
    const seconds = Math.max(0, Math.ceil((CHRISTMAS_CUTOFF - now) / 1000));
    return { expired: now >= CHRISTMAS_CUTOFF, hidden: now >= CHRISTMAS_END,
      days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24,
      minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
  }

  function ensureChristmasPromotion(header, story) {
    if (document.getElementById('intention-christmas') || christmasRemaining(Date.now()).hidden) return;
    const panel = document.createElement('section');
    panel.id = 'intention-christmas';
    panel.setAttribute('aria-labelledby', 'intention-christmas-heading');
    panel.innerHTML = `
      <div class="intention-christmas-inner">
        <svg class="intention-holiday-gift" viewBox="0 0 90 100" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
          <path d="M18 28Q14 28 14 34L17 85Q18 91 24 91L73 86L70 27Z M22 29L25 83L73 79 M19 84L69 80 M20 88L70 84 M42 29L47 82 M15 53L71 49"/>
          <path d="M43 29C18 27 23 8 34 14C40 17 43 24 43 29C44 16 57 7 61 15C66 23 53 29 43 29 M43 29L34 41 M43 29L55 39"/>
          <path d="M78 9L79 17 M75 13L83 12 M5 66L6 73 M2 70L10 69"/>
        </svg>
        <div class="intention-christmas-copy">
          <h2 id="intention-christmas-heading">Something personal under the tree.</h2>
          <p data-holiday-intro>Planning a Christmas gift? <strong>Order by December 8 for U.S. shipping.</strong></p>
        </div>
        <div class="intention-christmas-clock">
          <div class="intention-christmas-tiles" aria-hidden="true">
            <div><b data-holiday-days>00</b><span>Days</span></div>
            <div><b data-holiday-hours>00</b><span>Hours</span></div>
            <div><b data-holiday-minutes>00</b><span>Minutes</span></div>
            <div><b data-holiday-seconds>00</b><span>Seconds</span></div>
          </div>
          <p class="intention-christmas-accessible-cutoff">Order cutoff: Dec. 8, 11:59 p.m. Mountain Time</p>
        </div>
        <svg class="intention-holiday-sprig" viewBox="0 0 80 100" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true" focusable="false">
          <path d="M20 91Q42 54 58 10 M28 77L12 56 M28 77L51 69 M34 63L18 42 M34 63L59 54 M41 47L29 27 M41 47L65 38 M48 32L39 16 M48 32L67 23 M23 82L11 73 M23 82L41 83 M30 69L15 60 M37 54L24 44 M44 39L33 30"/>
          <g stroke="#8F3E3B"><circle cx="59" cy="65" r="3"/><circle cx="66" cy="59" r="3"/><circle cx="68" cy="69" r="3"/></g>
        </svg>
      </div>`;
    if (header) header.after(panel);
    else story.before(panel);
    let interval;
    const update = () => {
      const remaining = christmasRemaining(Date.now());
      panel.hidden = remaining.hidden;
      if (remaining.hidden || !panel.isConnected) {
        window.clearInterval(interval);
        document.removeEventListener('visibilitychange', update);
        return;
      }
      panel.querySelector('.intention-christmas-clock').hidden = remaining.expired;
      if (remaining.expired) {
        panel.querySelector('[data-holiday-intro]').textContent = 'Christmas delivery is no longer expected for new journal orders.';
      } else {
        for (const unit of ['days', 'hours', 'minutes', 'seconds']) {
          panel.querySelector(`[data-holiday-${unit}]`).textContent = String(remaining[unit]).padStart(2, '0');
        }
      }
    };
    update();
    interval = window.setInterval(update, 1000);
    document.addEventListener('visibilitychange', update);
    // No gift-card CTA until a real, tested purchase URL is approved.
  }

  function ensurePagePromotion() {
    if (!document.getElementById(PAGE_PROMO_STYLE_ID)) {
      const style = document.createElement('style');
      style.id = PAGE_PROMO_STYLE_ID;
      style.textContent = `
        .intention-free-shipping-banner {
          position: sticky;
          top: 0;
          z-index: 31;
          box-sizing: border-box;
          width: 100%;
          padding: 7px 12px;
          background: #965235;
          font-family: Arial, sans-serif;
          font-size: 12px;
          font-weight: 400;
          line-height: 1.55;
          letter-spacing: .05em;
          color: #fff;
          text-align: center;
        }
        html[data-intention-shipping-pinned] .intention-chrome-header {
          top: var(--intention-shipping-height, 33px);
        }
        #intention-christmas { background: #e3ebe1; color: #405B4B; border-bottom: 1px solid #cbd8c8; }
        #intention-christmas[hidden], #intention-christmas [hidden] { display: none !important; }
        .intention-christmas-inner { max-width: 1240px; margin: auto; padding: 20px 32px; display: flex; align-items: center; gap: 24px; }
        #intention-christmas h2 { font-family: Georgia, serif; font-size: clamp(21px, 2.2vw, 29px); font-weight: 400; line-height: 1.2; color: #405B4B; margin: 0 0 7px; }
        #intention-christmas p { font-family: Arial, sans-serif; font-size: 14px; line-height: 1.5; margin: 0; }
        #intention-christmas .intention-christmas-note { font-size: 12px; margin-top: 6px; max-width: 480px; }
        .intention-christmas-copy { flex: 1; }
        .intention-holiday-gift { width: 64px; height: 76px; flex-shrink: 0; color: #8F3E3B; transform: rotate(-6deg); }
        .intention-holiday-sprig { width: 58px; height: 84px; flex-shrink: 0; }
        .intention-christmas-clock { text-align: center; flex-shrink: 0; }
        .intention-christmas-tiles { display: flex; justify-content: center; gap: 8px; }
        .intention-christmas-tiles b { display: block; box-sizing: border-box; background: #fffdf9; border: 1px solid #deccc0; border-radius: 8px; padding: 6px 10px; min-width: 58px; font: 600 30px/1.2 Arial, sans-serif; font-variant-numeric: tabular-nums; color: #8F3E3B; }
        .intention-christmas-tiles span { display: block; margin-top: 4px; font: 10px/1.4 Arial, sans-serif; text-transform: uppercase; letter-spacing: .08em; }
        #intention-christmas .intention-christmas-clock p { font-size: 10px; margin-top: 6px; }
        #intention-christmas .intention-christmas-clock .intention-christmas-accessible-cutoff {
          position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px;
          overflow: hidden; clip-path: inset(50%); white-space: nowrap; border: 0;
        }
        @media (max-width: 760px) {
          .intention-christmas-inner { padding: 14px 20px; gap: 10px 14px; flex-wrap: wrap; }
          .intention-holiday-gift { width: 43px; height: 57px; }
          .intention-holiday-sprig { display: none; }
          .intention-christmas-copy { flex-basis: calc(100% - 60px); }
          #intention-christmas h2 { font-size: 21px; }
          #intention-christmas p { font-size: 12px; }
          #intention-christmas .intention-christmas-note { font-size: 11px; }
          .intention-christmas-clock { width: 100%; }
          .intention-christmas-tiles b { font-size: 25px; padding: 4px 10px; }
          .intention-free-shipping-banner {
            padding: 6px 10px;
            font-size: 11px;
          }
        }
      `;
      document.head.append(style);
    }

    const story = document.querySelector('.intention-story');
    if (story && !document.getElementById(PAGE_PROMO_ID)) {
      const target = document.querySelector('.intention-chrome-header')
        ?? story.closest('.shopify-section, .section-intention-story')
        ?? story.parentElement;
      if (target) {
        const banner = document.createElement('aside');
        banner.id = PAGE_PROMO_ID;
        banner.className = 'intention-free-shipping-banner';
        banner.setAttribute('aria-label', 'Free standard U.S. shipping');
        banner.textContent = 'Free standard U.S. shipping on every journal';
        target.before(banner);
        const measure = () => {
          document.documentElement.style.setProperty('--intention-shipping-height', `${banner.getBoundingClientRect().height}px`);
        };
        document.documentElement.setAttribute('data-intention-shipping-pinned', '');
        measure();
        if (typeof ResizeObserver !== 'undefined') new ResizeObserver(measure).observe(banner);
        else window.addEventListener('resize', measure);
      }
    }
    if (story) {
      ensureChristmasPromotion(document.querySelector('.intention-chrome-header'), story);
    }
  }

  function enhanceManualGoalPath(root) {
    if (root.host?.getAttribute(ENTRY_PATH_ATTR) !== 'manual') return;
    const heading = Array.from(root.querySelectorAll('h2')).find((item) => (
      item.textContent?.trim() === 'Your Goals. Your Way.'
    ));
    const intro = heading?.parentElement?.querySelector(':scope > p');
    const manualIntro = 'Type your goals below. Fill as many or as few squares as you like.';
    if (intro && intro.textContent !== manualIntro) {
      intro.textContent = manualIntro;
    }
  }

  function revealStartingOptions(gateway) {
    // Wait until both React and the gateway decoration have laid out the choices.
    window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
      if (!gateway.isConnected) return;
      const target = gateway.querySelector('.gateway-choice-prompt')
        ?? gateway.querySelector('.quiz-start-options');
      if (!target) return;
      let headerHeight = 0;
      const headers = new Set();
      for (const candidate of document.querySelectorAll(
        '.intention-free-shipping-banner, .intention-chrome-header, .shopify-section-header, sticky-header, header-component, header',
      )) {
        for (let element = candidate; element && element !== document.body;
          element = element.parentElement) headers.add(element);
      }
      for (const header of headers) {
        const style = window.getComputedStyle(header);
        const rect = header.getBoundingClientRect();
        if ((style.position === 'fixed' || style.position === 'sticky')
            && style.visibility !== 'hidden' && rect.height > 0 && rect.height < window.innerHeight) {
          headerHeight = Math.max(headerHeight, rect.height + Math.max(0, parseFloat(style.top) || 0));
        }
      }
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      window.scrollTo({
        top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerHeight - 16),
        behavior: 'instant',
      });
    }));
  }

  function enhanceGateway(root, gateway, returningFromFlow = false) {
    if (gateway.getAttribute(ENHANCED_ATTR) === 'true') return;
    gateway.setAttribute(ENHANCED_ATTR, 'true');
    clearEntryPath(root);

    const heading = gateway.querySelector('h2');
    const intro = gateway.querySelector(':scope > p:not(.quiz-product-context)');
    const options = Array.from(gateway.querySelectorAll('.quiz-start-option'));
    const productContext = gateway.querySelector('.quiz-product-context');

    if (heading) heading.textContent = 'What Would You Like to Make Happen?';
    if (intro) {
      intro.textContent = 'Start with goals you already have or get a little inspiration. You can edit every square, leave some blank, and make the journal completely yours.';
    }

    const kicker = document.createElement('p');
    kicker.className = 'gateway-kicker';
    kicker.textContent = 'CREATE YOUR JOURNAL';
    gateway.insertBefore(kicker, heading ?? gateway.firstChild);

    const visual = document.createElement('div');
    visual.className = 'gateway-visual';
    visual.innerHTML = `
      <img src="${HERO_IMAGE}" alt="A black Celestial Intention Squared hardcover journal shown open with lined pages" loading="eager">
      <div class="gateway-visual-badge">
        <div><strong>Your Goals, On Your Cover</strong><span>A journal made around what matters to you</span></div>
        <span class="gateway-price-pill"></span>
      </div>`;
    const pricePill = visual.querySelector('.gateway-price-pill');
    const priceText = storefrontPriceText(root);
    if (priceText) pricePill.textContent = priceText;
    else pricePill.remove();
    gateway.insertBefore(visual, kicker);

    const progress = document.createElement('ol');
    progress.className = 'gateway-progress';
    progress.setAttribute('aria-label', 'Journal creation steps');
    progress.innerHTML = `
      <li><b>1</b><span>Choose Your Starting Point</span></li>
      <li><b>2</b><span>Personalize Your Cover</span></li>
      <li><b>3</b><span>Review Your Proof</span></li>`;
    const optionGroup = gateway.querySelector('.quiz-start-options');
    gateway.insertBefore(progress, optionGroup ?? productContext ?? null);

    const choicePrompt = document.createElement('p');
    choicePrompt.className = 'gateway-choice-prompt';
    choicePrompt.textContent = 'Click a Button to Begin ↓';
    gateway.insertBefore(choicePrompt, optionGroup ?? productContext ?? null);

    const optionCopy = {
      manual: {
        title: 'Start With My Own Goals',
        body: 'Add your goals, fill as many squares as you like, and leave room for ideas that come later.',
        cta: 'Start My Journal',
        icon: manualIcon,
      },
      guided: {
        title: 'Help Me Find Ideas',
        body: 'Browse a ready-made collection or answer a few questions for personalized suggestions.',
        cta: 'Explore Ideas',
        icon: guidedIcon,
      },
    };

    options.forEach((button) => {
      const entryPath = button.classList.contains('quiz-start-guided') ? 'guided' : 'manual';
      const copy = optionCopy[entryPath];
      if (!copy) return;
      const title = button.querySelector('strong');
      const body = button.querySelector('span');
      if (title) title.textContent = copy.title;
      if (body) body.textContent = copy.body;

      const icon = document.createElement('span');
      icon.className = 'gateway-option-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = copy.icon;
      button.insertBefore(icon, title ?? button.firstChild);

      const cta = document.createElement('span');
      cta.className = 'gateway-option-cta';
      cta.innerHTML = `${copy.cta}<i aria-hidden="true">→</i>`;
      button.append(cta);
      button.setAttribute('aria-label', `${copy.title}. ${copy.body}`);
      button.addEventListener('click', () => {
        setEntryPath(root, entryPath);
        window.setTimeout(() => {
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          root.host?.scrollIntoView({ behavior, block: 'start' });
        }, 120);
      });
    });

    productContext?.remove();

    const reassurance = document.createElement('p');
    reassurance.className = 'gateway-reassurance';
    reassurance.innerHTML = '<strong>PRO TIP: Not ready to fill every square?</strong> Leave any square blank and pencil it in later after it’s printed.';
    gateway.append(reassurance);

    const cleanUrl = new URL(window.location.href);
    const returningFromReload = cleanUrl.searchParams.has('journal_start');
    if (returningFromReload) {
      cleanUrl.searchParams.delete('journal_start');
      window.history.replaceState({}, '', cleanUrl.toString());
    }
    if (returningFromReload || returningFromFlow) revealStartingOptions(gateway);
  }

  function enhanceBuilderReturn(root) {
    const heading = root.querySelector('.marketplace-product .product-heading');
    if (!heading || root.querySelector('.gateway-return-row')) return;

    const row = document.createElement('div');
    row.className = 'gateway-return-row';
    row.innerHTML = `
      <button type="button" class="gateway-return-button">
        <span aria-hidden="true">←</span>
        <span>Back to Starting Options</span>
      </button>
      <p class="gateway-return-note">Choose a different starting point. This starts a fresh journal.</p>`;

    row.querySelector('.gateway-return-button')?.addEventListener('click', () => {
      if (hasSavedProject(root) && !window.confirm(
        'This deletes your current project. Return to the starting options?',
      )) return;
      try {
        window.localStorage.removeItem(JOURNAL_DRAFT_KEY);
      } catch {}
      clearEntryPath(root);
      const returnUrl = new URL(window.location.href);
      returnUrl.searchParams.set('journal_start', '1');
      window.location.assign(returnUrl.toString());
    });
    heading.parentElement?.insertBefore(row, heading);
  }

  function stopCoverProgress() {
    if (coverProgressTimer !== null) {
      window.clearInterval(coverProgressTimer);
      coverProgressTimer = null;
    }
    activeCoverProgressPanel = null;
  }

  function enhanceCoverProgress(root) {
    // The React purchase flow now owns accurate request-state feedback.
    // Retire the elapsed-time percentage decorator without changing other enhancements.
    stopCoverProgress();
    root.querySelectorAll(`.${COVER_PROGRESS_CLASS}`).forEach((panel) => panel.remove());
  }

  function enhanceEmailGate(root, gate) {
    if (gate.getAttribute(EMAIL_ENHANCED_ATTR) === 'true') return;
    gate.setAttribute(EMAIL_ENHANCED_ATTR, 'true');

    const guidedQuiz = gate.closest('.guided-quiz');
    const heading = guidedQuiz?.querySelector('#guided-quiz-heading');
    const field = gate.querySelector('.quiz-text-field');
    const fieldLabel = field?.querySelector(':scope > span');
    const emailInput = field?.querySelector('input[type="email"]');
    const notice = gate.querySelector('.quiz-privacy-notice');
    const details = gate.querySelector('.quiz-privacy-details');
    const submit = gate.querySelector('.quiz-submit');

    if (heading) heading.textContent = 'Your Preview Is Ready to Create';

    const intro = document.createElement('p');
    intro.className = 'quiz-email-intro';
    intro.textContent = 'Enter your email to create your personalized journal preview.';
    gate.insertBefore(intro, field ?? gate.firstChild);

    if (fieldLabel) fieldLabel.textContent = 'Email Address';

    const optIn = document.createElement('label');
    optIn.className = 'quiz-marketing-optin';
    optIn.innerHTML = `
      <input type="checkbox" class="quiz-marketing-optin-input" checked>
      <span>Send me occasional goal inspiration, new designs, and special offers. I’ll confirm my subscription by email.</span>`;
    field?.after(optIn);

    // Keep the expandable usage disclosure; marketing permission is separate.

    if (submit) {
      submit.textContent = 'Create My Journal Preview';
      submit.addEventListener('click', () => {
        const checked = optIn.querySelector('input')?.checked === true;
        const email = emailInput?.value.trim() ?? '';
        pendingMarketingOptIn = checked && emailInput?.checkValidity() ? email : null;
      });
    }

    if (notice) {
      notice.id = 'intention-preview-email-notice';
      notice.innerHTML = 'Your email helps create your preview. Where your analytics settings allow, we keep protected repeat-use history for up to 364 days. Marketing emails are optional. <a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>';
      submit?.after(notice);
      if (emailInput) emailInput.setAttribute('aria-describedby', notice.id);
    }
  }

  function submitMarketingOptIn(email, root) {
    // Shopify's native form owns subscription and any confirmation/challenge.
    // Never treat a background POST as proof that a preview email was sent.
    if (window.IntentionPreviewSignup) {
      window.IntentionPreviewSignup.submit(email, root);
    } else {
      const notice = document.createElement('p');
      notice.setAttribute('role', 'status');
      notice.textContent = 'Email signup couldn’t load. You can still personalize and buy your journal.';
      root.prepend(notice);
    }
  }

  function connect() {
    const host = document.querySelector('intention-journal');
    if (!host) return;

    let attempts = 0;
    const waitForRoot = () => {
      const root = host.shadowRoot;
      if (!root) {
        attempts += 1;
        if (attempts < 240) window.setTimeout(waitForRoot, 25);
        return;
      }

      let hasShownFlow = false;
      const apply = () => {
        ensureStyles(root);
        ensurePagePromotion();
        const gateway = root.querySelector('.quiz-start');
        const shell = root.querySelector('.marketplace-product');
        const emailGate = root.querySelector('.quiz-email-gate');

        if (gateway) {
          shell?.classList.add('gateway-stage-shell');
          enhanceGateway(root, gateway, hasShownFlow);
        } else {
          if (shell) hasShownFlow = true;
          shell?.classList.remove('gateway-stage-shell');
          enhanceBuilderReturn(root);
          enhanceManualGoalPath(root);
          enhanceCoverProgress(root);
          if (emailGate) enhanceEmailGate(root, emailGate);
        }

        if (pendingMarketingOptIn && !emailGate) {
          const email = pendingMarketingOptIn;
          pendingMarketingOptIn = null;
          submitMarketingOptIn(email, root);
        }
      };

      restoreEntryPath(root);
      apply();
      new MutationObserver(apply).observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-busy', 'disabled'],
      });
    };

    waitForRoot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connect, { once: true });
  } else {
    connect();
  }
})();
